import PropTypes from 'prop-types';

export default PropTypes.arrayOf(PropTypes.shape({
  POSTED_ON: PropTypes.string,
  COMPANY_CODE: PropTypes.string,
  GL_ACCOUNT: PropTypes.string,
  TRADING_PARTNER: PropTypes.string,
  COST_CENTER: PropTypes.string,
  GEOGRAPHY: PropTypes.string,
  PROJECT: PropTypes.string,
  REFERENCE: PropTypes.string,
  BOOK_TYPE: PropTypes.string,
  CURRENCY_CODE: PropTypes.string,
  DEBIT: PropTypes.number,
  CREDIT: PropTypes.number,
  ACCT_DESCRIPTION: PropTypes.string,
})).isRequired;
